import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { ITableRow } from "app_quotation/shared/services/table-data/ITable";
import { ChapterType } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";

@Component({
    selector: 'td-container-block-content',
    template: `
        <ng-template #template>
            <td-separator *ngIf="element.block?.isFirstSectionBlockWithCost"
                          [blocksNumberInSection]="element.block.blockWithCostQuantity"
                          [isTrip]="element.chapterType === chapterType.trip"
                          [isLand]="element.chapterType !== chapterType.trip">
            </td-separator>
            <td-day [quotationOffset]="element.block.quotationOffset"
                    [parity]="parity"
                    [beginDate]="beginDate"
                    *ngIf="element.block.quotationOffset"></td-day>
            <td-block-title [title]="element.block.title"
                            [parity]="parity"
                            [colspan]="element.block.quotationOffset ? 1 : 2"
                            [category]="element.block.category"></td-block-title>
        </ng-template>
    `,
    styles: [`
        :host {
            display: none
        }
    `],
})

export class TdContainerBlockContentComponent implements OnInit {
    @Input()
    public element: ITableRow;
    @Input()
    public icon: string;
    @Input()
    public parity: "odd" | "even" = "odd";
    @Input()
    public beginDate: string;

    @ViewChild('template', {read: TemplateRef, static: true})
    public template: TemplateRef<ElementRef>;

    public chapterType: typeof ChapterType = ChapterType;

    constructor(
        private readonly viewContainerRef: ViewContainerRef
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
    }
}
